function isNetworkError(error) {
  return error && error.xhr;
}
export function getErrorStatusCode(crmError) {
  const networkError = crmError && 'networkError' in crmError ? crmError.networkError : undefined;
  if (!networkError || !isNetworkError(networkError)) {
    return undefined;
  }
  return networkError.status;
}